import apiConfig from "../config/api";

const draftApi = `${apiConfig.apiUri}api/complaints/draft`;
const denunciaApi = `${apiConfig.apiUri}api/complaints`;
const getToken = () => localStorage.getItem("AccessToken");

export const GetDenunciaPDF = (idDenuncia) =>
  fetch(`${denunciaApi}/pdfComplaint/${idDenuncia}`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });

export const GetDenunciasApi = (header) =>
  fetch(`${denunciaApi}/company`, {
    method: "GET",
    headers: {
      ...header,
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });

export const GetExcelDenunciasApi = (header) =>
  fetch(`${denunciaApi}/company/export`, {
    method: "GET",
    headers: {
      ...header,
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  }).then((response) => {
    if (response.status === 200) {
      return response.blob();
    }
    return 0;
  });

export const GetDenunciasPendientesTrabajador = ({
  CompanyRut, Rut, FechaIni, FechaEnd,
}) =>
  fetch(`${denunciaApi}/pending`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      RutEmpresa: CompanyRut,
      RutTrabajador: Rut,
      FechaDenunciaInicio: FechaIni,
      FechaDenunciaFin: FechaEnd,
    },
  });

export const GetValidacionTrabajadorEmpresa = ({
  CompanyRut, Rut, idTipoDenuncia,
}) =>
  fetch(`${denunciaApi}/validationEmployeeCompany`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      RutEmpresa: CompanyRut,
      RutTrabajador: Rut,
      TipoDenuncia: idTipoDenuncia,
    },
  });

export const GetDraftComplains = (companyRut, RutUsuario) =>
  fetch(`${draftApi}/${companyRut}/${RutUsuario}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const GetDraftComplainsById = (idDraft) =>
  fetch(`${draftApi}/${idDraft}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const CreateDraftComplains = (Data) =>
  fetch(`${draftApi}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: Data.IdComplaint ?
      `EmployeeRut=${Data.Rut}&CompanyRut=${Data.CompanyRut}&JsonData=${Data.jsonData}&UserRut=${Data.UserRut}&IdComplaint=${Data.IdComplaint}` :
      `EmployeeRut=${Data.Rut}&CompanyRut=${Data.CompanyRut}&JsonData=${Data.jsonData}&UserRut=${Data.UserRut}`
  });

export const UpdateDraftComplaint = (Data) =>
  fetch(`${draftApi}/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: `EmployeeRut=${Data.Rut}&CompanyRut=${Data.CompanyRut}&JsonData=${Data.jsonData}&UserRut=${Data.UserRut}&IdDraft=${Data.IdDraft}`
  });

export const DeleteDraftComplaint = (idComplaint) =>
  fetch(`${draftApi}/delete/${idComplaint}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const CreateNewComplaint = (jsonData) =>
  fetch(`${denunciaApi}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(jsonData)
  });

export const ViewPDFComplaint = (jsonData) =>
  fetch(`${denunciaApi}/pdfComplaint`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(jsonData)
  });

